import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "context";
import Main from "components/Layout/Main";
import Loader from "components/App/Loader";
import AuthGuard from "components/Secured/AuthGuard";
import Protected from "components/Secured/Protected";
import Register from "./Authentication/Register";
import BookingModule from "./Booking";
import ProfileRouter from "./Profile";
import OurAdsModule from "./OurAd";
import OurServicesModule from "./OurService";
import SubCategoryPage from "./SubCategory";
import Contact from "./Contact";
import MessagingRouter from "./Messaging";
import ProfileOtherPersonRouter from "./ProfileOtherPerson";
import NotificationPage from "app/Notification/Page";
import StripeModule from "./Stripe";
import { Role } from "types/user";
import { ROUTES, buildRoute } from "routes";

const Authentication = React.lazy(() => import("./Authentication"));
const Home = React.lazy(() => import("./Home"));
const Admin = React.lazy(() => import("./Admin"));
const ToolboxPage = React.lazy(() => import("./Toolbox"));
const AboutPage = React.lazy(() => import("./About"));
const FaqPage = React.lazy(() => import("./Faq"));
const CompaniesPage = React.lazy(() => import("./Companies"));

const ModuleRouter: React.FC = () => {
    const auth = useContext(AuthContext);

    if (auth.isLoading) {
        return <Loader />;
    }

    return (
        <Main>
            <Routes>
                <Route
                    index
                    element={auth.isLoggedIn && auth.isAllowed("admin.*") ? <Navigate to={ROUTES.ADMIN} /> : <Home />}
                />
                <Route path={ROUTES.TOOLBOX} element={<ToolboxPage />} />
                <Route path={`${ROUTES.ADS}/*`} element={<OurAdsModule />} />
                <Route path={`${ROUTES.PROVIDERS}/*`} element={<OurServicesModule />} />
                <Route path={`${ROUTES.CONTACT}/*`} element={<Contact />} />
                <Route path={ROUTES.ABOUT} element={<AboutPage />} />
                <Route path={ROUTES.FAQ} element={<FaqPage />} />
                <Route path={ROUTES.COMPANIES} element={<CompaniesPage />} />
                <Route path={`${buildRoute.stripeRedirect(":account_stripe_id")}`} element={<StripeModule />} />
                <Route
                    path={buildRoute.servicesByCategory(":category_label", ":sub_category_label")}
                    element={<SubCategoryPage />}
                />

                <Route path="/*" element={<Authentication />} />

                <Route element={<AuthGuard />}>
                    <Route path={`${ROUTES.OTHER_PROFILE}/*`} element={<ProfileOtherPersonRouter />} />
                    <Route path={`${ROUTES.ACCOUNT}/*`} element={<ProfileRouter />} />
                    <Route path={`${ROUTES.MESSAGING}/*`} element={<MessagingRouter />} />
                    <Route path={ROUTES.NOTIFICATIONS} element={<NotificationPage />} />
                    <Route
                        path={`${ROUTES.ADMIN}/*`}
                        element={<Protected capability="admin.*" element={<Admin />} />}
                    />
                    <Route
                        path={`${ROUTES.MY_RESERVATIONS}/*`}
                        element={<Protected capability="booking.*" element={<BookingModule />} />}
                    />
                    <Route path="/mes-favoris" element={<Navigate to={ROUTES.FAVORITES} replace />} />
                    {/* TODO: multiple roles */}
                    {((auth.account?.user.roles.includes("client") &&
                        !auth.account?.user.roles.includes(Role.PROVIDER)) ||
                        (auth.account?.user.roles.includes("provider") &&
                            !auth.account?.user.roles.includes(Role.CLIENT))) && (
                        <Route path={`${ROUTES.REGISTER}/*`} element={<Register />} />
                    )}
                </Route>

                <Route path="*" element={<Navigate to={ROUTES.HOME} />} />
            </Routes>
        </Main>
    );
};

export default ModuleRouter;
